import React, { useState } from 'react'
import EligibilityDocumentTitle from 'common/components/eligibility-document-title'
import useHppContext from 'common/hooks/use-hpp-context'
import postData from 'common/utils/post-data'
import { trackEvent, EVENTS } from 'common/utils/tracker'
import ChooseAmount from './choose-amount'
import AffordabilityForm from './affordability-form'
import InvalidAmount from './invalid-amount'
import fields from './fields'

function EligibilityPreAssessmentPage() {
  const {
    eligibility: {
      customerData = {},
      amount: {
        range: { min, max }
      }
    },
    actions: { success }
  } = useHppContext()

  const [amount, setAmount] = useState('')
  const [dialog, setDialog] = useState(null)
  const showAffordabilityForm = Object.keys(customerData).length > 0

  function onSubmit(values = {}) {
    const formFields = { purchase_amount: amount }

    for (let key in values) {
      const { name } = fields[key]

      formFields[name] =
        fields[key].type === 'IMPLICIT_DECIMAL' ? parseInt(values[key], 10) * 100 : values[key]
    }

    trackEvent(EVENTS.ELIGIBILITY_PRE_ASSESSMENT_SUBMIT)
    postData(success, formFields)
  }

  function closeDialog() {
    setDialog(null)
  }

  function onAmountChoose() {
    trackEvent(EVENTS.ELIGIBILITY_PRE_ASSESSMENT_AMOUNT_CHOSEN)
    if (Number(amount) < min || Number(amount) > max) {
      trackEvent(EVENTS.ELIGIBILITY_PRE_ASSESSMENT_INVALID_AMOUNT)
      setDialog(<InvalidAmount amount={amount} min={min} max={max} onClose={closeDialog} />)
    } else if (showAffordabilityForm) {
      setDialog(
        <AffordabilityForm customerData={customerData} onSubmit={onSubmit} onClose={closeDialog} />
      )
    } else {
      onSubmit()
    }
  }

  return (
    <>
      <EligibilityDocumentTitle />
      {dialog || (
        <ChooseAmount
          min={min}
          max={max}
          amount={amount}
          setAmount={setAmount}
          onSubmit={onAmountChoose}
        />
      )}
    </>
  )
}

export default EligibilityPreAssessmentPage
